export const apiConstants = {
  url: "/api/numberrange",
  doortypes: "/api/doortype",
  countries: "/api/country",
  labeltypes: "/api/labeltype"
};
